import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Modal,
  Alert,
  Badge,
} from "react-bootstrap";
import {
  getExchanges,
  addExchange,
  startEtradeExchangeAuth,
  completeEtradeExchangeAuth,
  deleteExchange,
  resetExchange,
  redirectExchange,
  snapTradeSuccessAction,
} from "../../actions/setting-action";
import { connect, useSelector } from "react-redux";
import "./AddApiPanel.scss";
import { ExchangeStatus, ExchangeStatusName } from "../../Const";
import { capitalize } from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SnapTradeReact } from 'snaptrade-react';
import { toast } from "react-toastify";
import LeftRightForm from "../bots/new-bot/modules/LeftRightForm";
import NoData from "../common/NoData";
import CustomRadio from "../bots/new-bot/modules/CustomRadio";
import { getExchangePairs } from "../../actions/bot-action";
import TransactionFee from "./TransactionFee";
import ConnectedExchangeCard from "./ConnectedExchangeCard";

const labelWidth = 3;
const EXCHANGE_ID_ETRADE_NATIVE = 130;
const EXCHANGE_ID_PUBLIC_COM = 202;
const EXCHANGE_IDS_ETORO = [203, 204];
const AddApiPanel = (props) => {
  const { getExchanges, getExchangePairs ,addExchange, startEtradeExchangeAuth, completeEtradeExchangeAuth, deleteExchange, resetExchange,redirectExchange,snapTradeSuccessAction } = props;
  const {t} = useTranslation()
  const history = useHistory();

  const detailCols = [3, 7, 2];
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [passphrase, setPassphrase] = useState("");
  const [exchangeId, setExchangeId] = useState(0);
  const [deleteId, setDeleteId] = useState(0);
  const [open, setOpen] = useState(false);
  const [etradeOauthToken, setEtradeOauthToken] = useState("");
  const [etradeLoginUrl, setEtradeLoginUrl] = useState("");
  const [etradeVerifier, setEtradeVerifier] = useState("");
  const [showEtradeVerifier, setShowEtradeVerifier] = useState(false);
  const snapLoginUrlUrl =  useSelector((state) => state.settings.exchangeLoginUrl) || '';
  const [snapTradeIframeUrl, setSnapTradeIframeUrl] = useState(snapLoginUrlUrl??"");

  const exchanges = useSelector((state) => state.settings.exchanges) || [];
  const selectedExchange = exchanges.find((el) => el.id == exchangeId) || {};
  const requiresCredentials = !selectedExchange.need_auth || selectedExchange.id === EXCHANGE_ID_ETRADE_NATIVE;
  const isEtradeNative = selectedExchange.id === EXCHANGE_ID_ETRADE_NATIVE;
  const isPublicCom = selectedExchange.id === EXCHANGE_ID_PUBLIC_COM;
  const isEtoro = EXCHANGE_IDS_ETORO.includes(Number(selectedExchange.id));
  const apiKeyLabel = isEtradeNative ? "Consumer Key" : t(isEtoro ? "public-key" : "api-key");
  const apiSecretLabel = isPublicCom ? "Public.com Secret Key" : isEtradeNative ? "Consumer Secret" : t(isEtoro ? "private-key" : "api-secret");
  const snapSuccessRedirectUrl =  useSelector((state) => state.settings.exchangeRedirectUrl) || '';

  useEffect(()=>{
    setSnapTradeIframeUrl(snapLoginUrlUrl)
  },[snapLoginUrlUrl])
  const addExchangeSuccess = useSelector(
    (state) => state.settings.addExchangeSuccess
  );
  const addExchangeError = useSelector(
    (state) => state.settings.addExchangeError
  );
  const addExchangeStart = useSelector(
    (state) => state.settings.addExchangeStart
  );
  const deleteExchangeSuccess = useSelector(
    (state) => state.settings.deleteExchangeSuccess
  );
  const deleteExchangeError = useSelector(
    (state) => state.settings.deleteExchangeError
  );

  const connectedExchanges = useMemo(
    () => exchanges.filter((item) => item.is_connected && item.id != 0),
    [exchanges]
  );
  const disconnectedExchanges = useMemo(
    () => exchanges.filter((item) => !item.is_connected && item.id != 0 && item.id != 4),
    [exchanges]
  );
  
  useEffect(() => {
    if (disconnectedExchanges.length) {
      setExchangeId(disconnectedExchanges[0].id);
    }
  }, [disconnectedExchanges]);

  useEffect(() => {
    getExchanges();
    //getExchangePairs(selectedExchange.id)
  }, []);

  useEffect(() => {
    resetExchange();
    return () => {
      resetExchange();
    };
  }, []);

  useEffect(() => {
    if (addExchangeSuccess) {
      setApiKey("");
      setApiSecret("");
      setPassphrase("");
      resetEtradeAuthorization();
      getExchanges();
    }
  }, [addExchangeSuccess]);

  const resetEtradeAuthorization = () => {
    setEtradeOauthToken("");
    setEtradeLoginUrl("");
    setEtradeVerifier("");
    setShowEtradeVerifier(false);
  };

  const openEtradeLogin = (url) => {
    if (!url) {
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const submitEtradeVerifier = () => {
    if (!etradeOauthToken) {
      toast.error("E*Trade authorization expired. Please restart the authorization.", { toastId: "etrade-token-required" });
      resetEtradeAuthorization();
      return;
    }
    if (!etradeVerifier.trim()) {
      toast.error("E*Trade verification code is required.", { toastId: "etrade-verifier-required" });
      return;
    }

    completeEtradeExchangeAuth({
      oauth_token: etradeOauthToken,
      oauth_verifier: etradeVerifier.trim(),
    })
      .then(() => {
        resetEtradeAuthorization();
      })
      .catch((err) => {
        toast.error(err || "Unable to complete E*Trade authorization.", { toastId: "etrade-complete-error" });
      });
  };

  const clickAdd = () => {
    const params = {
      id: String(exchangeId),
      api_key: isPublicCom ? "" : apiKey,
      secret: exchangeId==1000 ? passphrase: apiSecret,
      account: passphrase,
    };
    if (selectedExchange.id == 1000) {
      if (!passphrase) {
        toast.error("Pin is required.", { toastId: "pin-required" });
        return;
      }
    }
    if (requiresCredentials) {
      if (!isPublicCom && !apiKey) {
        toast.error(t("api-credential-required", { field: apiKeyLabel }), { toastId: "api-key-required" });
        return;
      }
      if (!apiSecret) {
        toast.error(t("api-credential-required", { field: apiSecretLabel }), { toastId: "api-secret-required" });
        return;
      }
    }
    if(isEtradeNative){
      startEtradeExchangeAuth(params)
        .then((res) => {
          setEtradeOauthToken(res.oauth_token);
          setEtradeLoginUrl(res.exchange_login_url);
          setEtradeVerifier("");
          setShowEtradeVerifier(true);
          openEtradeLogin(res.exchange_login_url);
        })
        .catch((err) => {
          toast.error(err || "Unable to start E*Trade authorization.", { toastId: "etrade-start-error" });
        });
      return;
    }
    if(selectedExchange.is_snap_trade){
      redirectExchange(params).then((res)=>{
        setOpen(true);
        //history.push("/add-brokerage");
      })
      //addExchange(params);
    }
    else{
      addExchange(params);
    }
  };

  const onSuccessFn = (res) => {
    //snapTradeSuccessAction(snapSuccessRedirectUrl)
    window.location.href= snapSuccessRedirectUrl
    resetExchange();
  };

  const onErrorFn = (msg: string) => {
    setOpen(false);
    resetExchange();
    toast.error("ERROR: " + msg.detail, {
      toastId: "error"
    });
  };
  const onExitFn = () => {
    setOpen(false)
    resetExchange();
  };


  const clickDelete = () => {
    deleteExchange(deleteId);
    setDeleteId(0);
  };
  const [feeItems, setFeeItems] = useState([
  ]);
  

  

  const connectedItems = connectedExchanges.map((item, index) => {
    return (
      <ConnectedExchangeCard key={index} exchange={item} t={t}></ConnectedExchangeCard>
    );
  });
  

  const disconnectedItems = disconnectedExchanges.map((item, index) => {
    return (
      <div className={`pointer col-md-12 col-xs-12 name-div ${item.id===exchangeId?"active":""}`} key={item.id} onClick={() => setExchangeId(item.id)}>
        
          <div className="col-md-2 col-xs-2 no-padding w-m-20"><img src={item.image} alt="icon" width={20} className="mr-10"/></div>
          <div className="col-md-10 col-xs-10 w-m-80">{item.name}</div>
      </div>
    );
  });

  return (
    <>
    <div className="col-sm-10 setting-right-col">
	<div className="setting-exchange-area"> 
		<div className="add-brokerage-area">
			<h4><a  href="#"><img src="/images/icon-exchange.svg" alt=""/> Add New Brokerage</a></h4>
			<div className="brokerage-logos">
				{disconnectedItems}
				
			</div>
			<div className="brokerage-footer">
      {requiresCredentials ? (
                  <>
                  {!isPublicCom && (
                  <Form.Group as={Row} controlId="add-exchange-api-key">
                    <Form.Label column sm={labelWidth}>
                      {apiKeyLabel}
                    </Form.Label>
                    <Col sm={12 - labelWidth}>
                      <Form.Control
                        as="input"
                        value={apiKey}
                        onChange={(e) => setApiKey(e.target.value)}
                        className="input-text"
                      />
                    </Col>
                  </Form.Group>
                  )} 
                  <Form.Group as={Row} className="mt-2" controlId="add-exchange-api-secret">
                    <Form.Label column sm={labelWidth}>
                      {apiSecretLabel}
                    </Form.Label>
                    <Col sm={12 - labelWidth}>
                      <Form.Control
                        as="input"
                        value={apiSecret}
                        onChange={(e) => setApiSecret(e.target.value)}
                        className="input-text"
                      />
                    </Col>
                  </Form.Group> </>):(<></>)}
                  {selectedExchange.require_param ||  selectedExchange.id ==1000 ? (
                    <Form.Group as={Row}>
                      <Form.Label column sm={labelWidth}>
                        {capitalize(selectedExchange.require_param || "PIN")}
                      </Form.Label>
                      <Col sm={12 - labelWidth}>
                        <Form.Control
                          as="input"
                          value={passphrase}
                          onChange={(e) => setPassphrase(e.target.value)}
                          className="input-text"
                        />
                      </Col>
                    </Form.Group>
                  ) : (
                    <></>
                  )}
                  <br /><br />
				<p>a Broker marked with a Beta tag indicates a newly launched service in StockHero</p>
        <br />
        <div className="row justify-content-center">
          <br />
        <button href="#" className="blue-button" onClick={clickAdd}>{addExchangeStart ? "Updating..." : (isEtradeNative ? "Start E*Trade Authorization" : (selectedExchange.need_auth ? t("authenticate"):t("add-exchange")))}</button>
        {isEtradeNative ? <span>Approve access on E*Trade, then paste the verification code shown by E*Trade.</span> : (selectedExchange.need_auth ? <span>You will be directed to {selectedExchange.name}</span>:<></>)}
        </div>
				
        <Row className="justify-content-center mt-2">
          <Alert
            show={addExchangeSuccess || addExchangeError != null}
            variant={addExchangeError ? "danger" : "success"}
          >
            {addExchangeError || "Brokerage added!"}
          </Alert>
        </Row>
        {selectedExchange && (!selectedExchange.is_snap_trade || selectedExchange.id == 14) && selectedExchange.doc_link && 
          <div style={{ textAlign: "right", marginTop: 20 }}>
            <a href={selectedExchange.doc_link} target="_blank">
              * {t("how-to-connect")} {selectedExchange.name}?
            </a>
          </div> }
			</div>
      <SnapTradeReact
                  loginLink={snapTradeIframeUrl}
                  isOpen={open}
                  close={() => onExitFn()}
                  onSuccess={onSuccessFn}
                  onError={onErrorFn}
                  onExit={onExitFn}
                />
		</div>
    <br /><br />
    {connectedItems.length > 0 && 
		<div className="connected-brokerage-area mb-5">
			<h4>{t("connected-exgs")}</h4>
			<div className="row g-2">
			  {connectedItems}
			</div>
		</div> }
	</div>
</div>

      <Modal show={deleteId > 0} onHide={() => setDeleteId(0)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("warning")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("delete-api-warning")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={clickDelete}>
            {t("delete")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showEtradeVerifier} onHide={resetEtradeAuthorization}>
        <Modal.Header closeButton>
          <Modal.Title>E*Trade Authorization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Approve StockHero access on E*Trade. After approval, E*Trade will show a verification code.
            Paste that code below to finish connecting your brokerage.
          </p>
          {etradeLoginUrl ? (
            <div className="mb-3">
              <a href={etradeLoginUrl} target="_blank" rel="noopener noreferrer" className="blue-button">
                Open E*Trade Authorization
              </a>
            </div>
          ) : (
            <></>
          )}
          <Form.Group>
            <Form.Label>Verification Code</Form.Label>
            <Form.Control
              as="input"
              value={etradeVerifier}
              onChange={(e) => setEtradeVerifier(e.target.value)}
              className="input-text"
              placeholder="Paste E*Trade verification code"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={resetEtradeAuthorization} disabled={addExchangeStart}>
            Restart
          </Button>
          <Button variant="primary" onClick={submitEtradeVerifier} disabled={addExchangeStart}>
            {addExchangeStart ? "Completing..." : "Complete Authorization"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default connect(null, {
  getExchanges,
  getExchangePairs,
  addExchange,
  startEtradeExchangeAuth,
  completeEtradeExchangeAuth,
  deleteExchange,
  resetExchange,
  redirectExchange,
  snapTradeSuccessAction
})(AddApiPanel);
